module.exports = __webpack_public_path__ + "static/media/ready-to-sell.b2573dd2.jpg";